import { useState, useCallback } from 'react';

export const useNotification = () => {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback((message, type = 'error', duration = 5000) => {
    setNotification({ message, type, duration });
  });

  const showError = useCallback((message, duration = 5000) => {
    showNotification(message, 'error', duration);
  });

  const showSuccess = useCallback((message, duration = 5000) => {
    showNotification(message, 'success', duration);
  });

  const showWarning = useCallback((message, duration = 5000) => {
    showNotification(message, 'warning', duration);
  });

  const showInfo = useCallback((message, duration = 5000) => {
    showNotification(message, 'info', duration);
  });

  const hideNotification = useCallback(() => {
    setNotification(null);
  });

  return {
    notification,
    showNotification,
    showError,
    showSuccess,
    showWarning,
    showInfo,
    hideNotification,
  };
};

